import React from 'react'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { getBoundActions } from '../../../actions/index'
import { Tabs, Tab, TABS_JUSTIFY } from '../../Tabs/index'
import { COURSE_STATE_COMPLETE } from '../../../services/detail/index'
import DetailPageV3CourseResources from './DetailPageV3CourseResources'
import DetailPageV3CourseOverview from './DetailPageV3CourseOverview'
// import DetailPageV3CourseRelated from './DetailPageV3CourseRelated'
import DetailPageV3CoursePractice from './DetailPageV3CoursePractice'
import DetailPageV3Comments from '../DetailPageV3Comments'

/**
 * Course detail page tabs component
 * @param {Object} props - The props
 * @param {Map} props.detailData - The content details data
 * @param {List} props.modulesData - The course modules data
 * @param {List} props.resourcesData - The course resources data
 * @param {List} props.practicesData - The course practices data
 * @param {Map} props.progressData - The course progress data
 * @param {function} props.onCourseStateChange - The function to handle course state change
 * @param {Map} props.featuredContent - The featured content data
 * @param {Map} props.staticText - The static text data
 * @returns {JSX.Element} DetailPageV3CourseTabs
 */

const DetailPageV3CourseTabs = (props) => {
  const {
    detailData = Map(),
    modulesData = List(),
    resourcesData = List(),
    practicesData = List(),
    progressData = Map(),
    onCourseStateChange,
    featuredContent = Map(),
    staticText,
  } = props

  const courseState = progressData.get('state')

  return (
    <Tabs
      justify={TABS_JUSTIFY.LEFT}
      activeTab={courseState === COURSE_STATE_COMPLETE ? 1 : 0}
    >
      <Tab key={0} label={staticText.get('overview')}>
        <DetailPageV3CourseOverview
          detailData={detailData}
          modulesData={modulesData}
          featuredContent={featuredContent}
          progressData={progressData}
          onCourseStateChange={onCourseStateChange}
        />
        <div id="commentsBlock"></div>
        <DetailPageV3Comments
          title={staticText.get('comments')}
          detailData={detailData}
          showCount
        />
      </Tab>
      <Tab key={1} label={`${staticText.get('practice')} (${practicesData.size})`}>
        <DetailPageV3CoursePractice practicesData={practicesData} detailData={detailData} />
      </Tab>
      <Tab key={2} label={`${staticText.get('additionalResources')} (${resourcesData.size})`}>
        <DetailPageV3CourseResources resourcesData={resourcesData} />
      </Tab>
      {/* <Tab key={3} label={staticText.get('related')}>
        <DetailPageV3CourseRelated detailData={detailData} />
      </Tab> */}
      <Tab key={4} label={staticText.get('comments')}>
        <DetailPageV3Comments
          title={staticText.get('comments')}
          detailData={detailData}
          showCount
        />
      </Tab>
    </Tabs>
  )
}

export default connectRedux((state) => ({
  staticText: state.staticText.getIn(['data', 'detailPageV3', 'data'], Map()),
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CourseTabs)
